import React, { useState } from 'react';
import { Box } from '@mui/material';
import DocumentItem from '../DocumentItem/DocumentItem';
import { DisplayedDocument } from '../../../providers/types';

export type DownloadableDocumentItemProps = {
    onDownload: () => void;
    onShow: () => void;
    onSign?: () => void;
    onDownloadSigned?: () => void;
} & DisplayedDocument;

const DownloadableDocumentItem: React.FunctionComponent<DownloadableDocumentItemProps> = function (
    props,
) {
    const {
        onDownload: handleDownload,
        label,
        fileName,
        type,
        showable,
        downloadable,
        canDownloadSigned,
        onShow,
        onSign,
        onDownloadSigned,
    } = props;
    const [isMouseHover, setIsMouseHover] = useState<number>(0);
    const handleMouseEnter = () => setIsMouseHover((val) => val + 1);
    const handleMouseLeave = () => setIsMouseHover((val) => val - 1);

    return (
        <Box
            data-testid="downloadable-documents-item"
            onClick={handleDownload}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <DocumentItem
                label={label as string}
                fileName={fileName}
                type={type}
                hover={isMouseHover > 0}
                uploadable={false}
                uploading={false}
                color="primary"
                sx={{ cursor: 'pointer' }}
                itemActions={{
                    ...(showable && {
                        onShow: (e) => {
                            if (e) e.stopPropagation();
                            onShow();
                        },
                        showTooltip: 'Afficher le document',
                    }),
                    ...(downloadable && {
                        onDownload: () => handleDownload(),
                        downloadTooltip: 'Télécharger le document',
                    }),
                    ...(onSign && {
                        onSign: (e) => {
                            if (e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            onSign();
                        },
                        signTooltip: 'Signer le document',
                    }),
                    ...(canDownloadSigned &&
                        onDownloadSigned && {
                            onDownloadSigned: (e) => {
                                if (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                                onDownloadSigned();
                            },
                            downloadSignedTooltip: 'Télécharger le document signé',
                        }),
                }}
            />
        </Box>
    );
};

export default DownloadableDocumentItem;
